// Transform Dawn's PDP media grid into a single-image slider with prev/next arrows
// + optional thumbnail strip below.
//
// Works with Dawn's existing markup (.product__media-list + .product__media-item)
// so variant image swaps and lightbox zoom keep working.

(function () {
  function initGallery(root = document) {
    const lists = root.querySelectorAll('.product__media-list.contains-media')
    lists.forEach((list) => {
      if (list.dataset.bamGalleryReady) return
      list.dataset.bamGalleryReady = '1'

      const items = Array.from(list.querySelectorAll('.product__media-item'))
      if (items.length < 1) return

      const wrap = list.closest('media-gallery') || list.parentElement
      if (!wrap) return

      // Wrap the media list in a carousel container we control
      const carousel = document.createElement('div')
      carousel.className = 'bam-pdp-carousel'
      list.parentNode.insertBefore(carousel, list)
      carousel.appendChild(list)
      list.classList.add('bam-pdp-carousel__track')

      // Prev / Next arrows
      const prev = document.createElement('button')
      prev.type = 'button'
      prev.className = 'bam-pdp-arrow bam-pdp-arrow--prev'
      prev.setAttribute('aria-label', 'Previous image')
      prev.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg>'

      const next = document.createElement('button')
      next.type = 'button'
      next.className = 'bam-pdp-arrow bam-pdp-arrow--next'
      next.setAttribute('aria-label', 'Next image')
      next.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg>'

      carousel.appendChild(prev)
      carousel.appendChild(next)

      // Counter (1 / N)
      const counter = document.createElement('div')
      counter.className = 'bam-pdp-counter'
      carousel.appendChild(counter)

      // Thumbnail strip below (uses the same items as image sources)
      const thumbs = document.createElement('div')
      thumbs.className = 'bam-pdp-thumbs'
      items.forEach((item, i) => {
        const img = item.querySelector('img')
        if (!img) return
        const thumb = document.createElement('button')
        thumb.type = 'button'
        thumb.className = 'bam-pdp-thumb'
        thumb.setAttribute('aria-label', `Show image ${i + 1}`)
        thumb.dataset.index = String(i)
        const thumbImg = document.createElement('img')
        thumbImg.src = img.currentSrc || img.src
        thumbImg.alt = img.alt || ''
        thumbImg.loading = 'lazy'
        thumb.appendChild(thumbImg)
        thumbs.appendChild(thumb)
      })
      carousel.parentNode.insertBefore(thumbs, carousel.nextSibling)

      let committedIndex = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')))
      if (committedIndex < 0) committedIndex = 0
      let currentIndex = committedIndex

      // Build color-slug → index map from alt="bam-color:<slug>" (set at upload).
      const colorSlugToIndex = new Map()
      items.forEach((item, i) => {
        const img = item.querySelector('img')
        const alt = img?.getAttribute('alt') || ''
        const m = alt.match(/^bam-color:([\w-]+)/)
        if (m) colorSlugToIndex.set(m[1], i)
      })

      const updateState = () => {
        counter.textContent = `${currentIndex + 1} / ${items.length}`
        thumbs.querySelectorAll('.bam-pdp-thumb').forEach((t, i) => {
          t.classList.toggle('is-current', i === currentIndex)
        })
        prev.disabled = currentIndex === 0
        next.disabled = currentIndex === items.length - 1
      }

      const scrollToIndex = (i, opts = {}) => {
        const clamped = Math.max(0, Math.min(items.length - 1, i))
        const target = items[clamped]
        if (!target) return
        list.scrollTo({ left: target.offsetLeft - list.offsetLeft, behavior: opts.behavior || 'smooth' })
        currentIndex = clamped
        if (opts.commit !== false) committedIndex = clamped
        updateState()
      }

      prev.addEventListener('click', () => scrollToIndex(currentIndex - 1))
      next.addEventListener('click', () => scrollToIndex(currentIndex + 1))
      thumbs.addEventListener('click', (e) => {
        const t = e.target.closest('.bam-pdp-thumb')
        if (!t) return
        scrollToIndex(Number(t.dataset.index))
      })

      // Sync committed index on user scroll / swipe.
      let scrollTimer = null
      list.addEventListener('scroll', () => {
        clearTimeout(scrollTimer)
        scrollTimer = setTimeout(() => {
          const listRect = list.getBoundingClientRect()
          let closest = 0
          let closestDist = Infinity
          items.forEach((item, i) => {
            const rect = item.getBoundingClientRect()
            const dist = Math.abs(rect.left - listRect.left)
            if (dist < closestDist) {
              closestDist = dist
              closest = i
            }
          })
          if (closest !== currentIndex) {
            currentIndex = closest
            committedIndex = closest
            updateState()
          }
        }, 120)
      }, { passive: true })

      // Public API for hover-preview from color swatches.
      carousel.bamPreviewColor = (colorSlug) => {
        const idx = colorSlugToIndex.get(colorSlug)
        if (idx == null) return false
        scrollToIndex(idx, { commit: false, behavior: 'auto' })
        return true
      }
      carousel.bamRestore = () => {
        scrollToIndex(committedIndex, { commit: false, behavior: 'auto' })
      }
      carousel.bamCommitColor = (colorSlug) => {
        const idx = colorSlugToIndex.get(colorSlug)
        if (idx == null) return false
        scrollToIndex(idx, { commit: true, behavior: 'smooth' })
        return true
      }

      // Keyboard support
      carousel.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); scrollToIndex(currentIndex - 1) }
        if (e.key === 'ArrowRight') { e.preventDefault(); scrollToIndex(currentIndex + 1) }
      })
      carousel.setAttribute('tabindex', '0')

      // Snap to initial active image
      requestAnimationFrame(() => {
        scrollToIndex(currentIndex, { behavior: 'auto' })
      })
    })
  }

  document.addEventListener('DOMContentLoaded', () => initGallery())
  document.addEventListener('shopify:section:load', (e) => initGallery(e.target))
})()
